import type { CSSProperties } from "react";
import { factionFor, ORNAMENT_SIGIL } from "../theme/factions";

// Pixel sigil drawn via CSS mask, so a single white-on-transparent PNG
// can be tinted any color. Source PNGs are pre-upscaled to 64×64 so
// rendering at 12px+ stays crisp.
export function Sigil({
  faction,
  src,
  color,
  size = 32,
  style,
  className,
  title,
}: {
  /** Faction key. Ignored if `src` is provided. */
  faction?: string | null;
  /** Explicit image URL (e.g. ORNAMENT_SIGIL). */
  src?: string;
  /** Override sigil ink; defaults to the faction's `sigilInk`. */
  color?: string;
  /** Number (px) or any CSS length string. */
  size?: number | string;
  style?: CSSProperties;
  className?: string;
  title?: string;
}) {
  const f = faction != null ? factionFor(faction) : null;
  const url = src ?? f?.sigil ?? ORNAMENT_SIGIL;
  const fill = color ?? f?.sigilInk ?? "currentColor";

  const css: CSSProperties = {
    display: "inline-block",
    width: size,
    height: size,
    backgroundColor: fill,
    WebkitMaskImage: `url(${url})`,
    maskImage: `url(${url})`,
    WebkitMaskRepeat: "no-repeat",
    maskRepeat: "no-repeat",
    WebkitMaskPosition: "center",
    maskPosition: "center",
    WebkitMaskSize: "contain",
    maskSize: "contain",
    flexShrink: 0,
    verticalAlign: "middle",
    ...style,
  };

  return <span aria-hidden="true" title={title} className={className} style={css} />;
}
